var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main_page"},[_c(_setup.NavComponent),_c('v-main',{staticClass:"hero"},[_c('div',{staticClass:"hero-bg"}),(_setup.isPion)?_c('div',{staticClass:"inquiry-wrapper"},[_c(_setup.InquiryBoard)],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }